export const textOverride = (text_overrides, key, default_value = null) => {
  if (!text_overrides) return default_value;

  const custom_text = text_overrides[key];

  if (!custom_text || custom_text.length === 0) return default_value;

  return custom_text;
}
